'use client';

import { logOut } from '@/app_lib/services/tinypass/clientHelpers';
import { ContentPlacement } from '@/app_lib/types/analytics';

export const SignOutButton = () => {
  const handleSignOut = () => {
    logOut();
  };

  return (
    <button
      className='cursor-pointer hover:text-neutral-400 focus:text-accent-primary'
      data-cy={ContentPlacement.SignOutButton}
      onClick={handleSignOut}
      type='button'
    >
      Sign Out
    </button>
  );
};
